<template>
  <SubContent @back="$router.go(-1)">
    <template v-slot:nav_left> 精英训练营报名详情 </template>
    <div v-if="!isLoading" class="scroll_wrap">
      <vue-scroll>
        <div class="info_item" style="margin-bottom: 0">
          <div class="info_title" style="justify-content: space-between">
            <div style="display: flex; align-items: center">
              <img
                src="@/assets/images/common/group_member.png"
                style="width: 0.25rem; height: 0.2rem"
                alt=""
              />
              <p>会员协会已提交{{trainCampInfo.enrollType | typeFilter}}列表</p>
            </div>
          </div>
          <div class="titleWrap" >
            <div style="display:flex;align-items:center;padding: 10px 0;">


              <div class="search_box">
                <input
                  v-model.trim="selectVal.keywords"
                  type="text"
                  class="yioks_input"
                  placeholder="请输入关键词"
                  @keyup.enter="changeQuery(true)"
                >
                <div class="yioks_btn" @click="changeQuery(true)"
                     style="font-size:18px;padding:5px">搜索
                </div>
              </div>
            </div>


            <div class="list_wrap">
              <div v-if="showList" class="table">
                <div class="thead">
                  <div class="tr">
                    <div class="th seq"><strong>序号</strong></div>
                    <div class="th name"><strong>姓名</strong></div>
                    <div class="th id_number"><strong>身份证号</strong></div>
                    <div class="th organ"><strong>提交机构</strong></div>
                    <div class="th weizhi"><strong>场上位置</strong></div>
                    <div class="th foot"><strong>操作</strong></div>
                  </div>
                </div>
                <div class="scrollArea">
                  <div class="tbodyWrap">
                    <div class="tbody">
                      <div v-for="(item, index) in playerList"
                           :key="index"
                           class="tr">
                        <div class="td seq">
                          <p>{{index+1}}</p>
                        </div>
                        <div class="td name" style="display:grid;text-align:center">
                          <p>{{item.idName}}</p>
                        </div>
                        <div class="td id_number">
                          <p>{{item.idNumber | filterIdNumberPrivacy}}</p>
                        </div>
                        <div class="td organ" >
                          <p>{{item.youthShortName}}</p>
                        </div>
                        <div class="td weizhi">
                          <p>{{item.position}}</p>
                        </div>
                        <div class="td foot">
                          <p style="color:#4cd964;cursor:pointer" @click="goDetail(item.playerUuid)">查看</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <yioks-loading v-if="loading" />
              <yioks-empty v-if="empty" style="margin-top:35px" />
            </div>
            <Pagination :total="total" :pageSize="pageSize" :page.sync="page"/>
          </div>
        </div>
        <div class="info_item">
          <div class="info_title">
            <img src="@/assets/images/common/player_information.png" alt="" />
            基础信息
          </div>
          <div class="base_info">
            <div class="info">
              <div class="col">
                <span>名称：{{trainCampInfo.enrollName}}</span>
                <span v-if="trainCampInfo.enrollType === 'player'">球员年龄段 ：{{trainCampInfo.playerAges}}</span>
              </div>
              <div class="col">
                <span>训练营计划月份：{{trainCampInfo.trainCampStartTime | timeYearAndMonth(false, false)}} 至 {{trainCampInfo.trainCampEndTime | timeYearAndMonth(false, false)}}</span>
                <span> 名单提交截止时间：{{trainCampInfo.enrollEndTime | time}}</span>
              </div>
              <fieldset class="vita-form-fieldset" style="border: 1px dashed white;padding: 10px ; margin: 10px 15px 15px 15px"  >
                <legend>训练营报名信息</legend>
                <div v-if="trainCampInfo.intro" v-html="trainCampInfo.intro"></div>
                <div v-else>--</div>
              </fieldset>
            </div>
          </div>
        </div>
      </vue-scroll>
    </div>
  </SubContent>
</template>
<script>
  import trainCamp from '@/api/trainCampEnroll'
  import { trainCampEnrollType } from '@/utils/yioks_filter'
  import org from '@/api/org'
  import {
    isCfaTestList,
  } from '@/utils/yioks_data'
  export default {
    name: "trainCampEnrollInfo",
    data() {
      const nationwideTestList = Array(80)
      .fill("")
      .map((item, idx) => {
        return {
          name: "第"+Number(idx+1)+"名",
          value: Number(idx+1).toString(),
        };
      });
      const cfaTestRankList = Array(64)
      .fill("")
      .map((item, idx) => {
        return {
          name: "第"+Number(idx+1)+"名",
          value: Number(idx+1).toString(),
        };
      });
      const organTestRankList = Array(8)
      .fill("")
      .map((item, idx) => {
        return {
          name: "第"+Number(idx+1)+"名",
          value: Number(idx+1).toString(),
        };
      });
      return {
        isCfaTestList,
        nationwideTestList:[{name:"其他名次或未参加",value:"其他名次或未参加"}].concat(nationwideTestList),
        cfaTestRankList:[{name:"其他名次或未参加",value:"其他名次或未参加"}].concat(cfaTestRankList),
        organTestRankList:organTestRankList.concat({name:"无",value:"无"}),
        isLoading: false,
        loading: false,
        showList: true,
        empty: false,
        total: 0,
        page: 0,
        pageSize: 20,
        trainCampInfo:{},
        organPlaces:[],
        regionList:[],
        batchInfo: {
          groupNum:""
        },
        playerInfo:{},
        isShowDialog:false,
        isShowDialog2024:false,
        isShowDialog2024Man:false,
        playerList:[],
        selectVal:{
          organUuid:"",
          youthUuid:"",
          enrollUuid:"",
          keywords:"",
        }
      }
    },
    components: {
      SubContent: () => import("@/components/layout/newSubContent"),
      'Pagination': () => import('@/components/Pagination'),
      "yioks-tips": () => import("@/components/YioksTip"),
//      "player-info": () => import("@/components/trainCampEnroll/playerInfo"),
//      "player-info2024": () => import("@/components/trainCampEnroll/playerInfo2024"),
//      "player-info2024Man": () => import("@/components/trainCampEnroll/playerInfo2024Man"),
    },
    computed: {
      enrollUuid(){
        const uuid = this.$route.query.enrollUuid || "";
        return uuid;
      },
    },
    filters: {
      typeFilter(val){
        return trainCampEnrollType(val)
      }
    },
    created() {
      const { page, organUuid,enrollUuid, youthUuid, keywords } =
        this.$route.query;
      page && (this.page = Number(page));
      organUuid && this.$set(this.selectVal, "organUuid", organUuid);
      enrollUuid && this.$set(this.selectVal, "enrollUuid", enrollUuid);
      youthUuid && this.$set(this.selectVal, "youthUuid", youthUuid);
      keywords && this.$set(this.selectVal, "keywords", keywords);
      this.trainCampEnrollInfo();
      this.changeQuery();
    },
    watch: {
      page() {
        this.changeQuery();
      },
    },
    methods: {
      goDetail(uuid){
        this.$router.push({
          path: '/player/info',
          query: {
            uuid
          }
        })
      },
      goTrain(item){
        this.$router.push({
          path: '/trainCampPlan/info',
          query: {
            planUuid:item.trainPlanUuid
          }
        })
      },
      showPlayer(val){
        this.$router.push({
          path: '/player/info',
          query: {
            uuid:val
          }
        })
      },
      changeQuery(flag) {
        if (flag) this.page = 0;
        this.$router.replace({
          path: this.$route.path,
          query: {
            ...this.selectVal,
            page: this.page,
            enrollUuid: this.enrollUuid,
          },
        });
        this.trainCampPlanPlayerList();
      },
      trainCampEnrollInfo(){
        trainCamp.getTrainCampEnrollInfo(this.enrollUuid).then(
          (res)=>{
            if (!res.code) {
              this.trainCampInfo = res;
            }else{
              this.$message.error(res.msg);
            }
          }
        ).catch((err) => {
          console.error(err)
        })
      },
      trainCampPlanPlayerList(){
        this.showList = false
        this.empty = false
        this.loading = true
        let data = {
          ...this.selectVal,
          page: this.page,
          size: this.pageSize,
          enrollUuid:this.enrollUuid,
        }
        trainCamp.getTrainCampPlanPlayerListSystem(data).then(
          (res)=>{
            this.loading = false
            if (!res.code) {
              this.total = res.totalElements;
              if (res.content.length){
                this.showList = true
                this.playerList = res.content;
              }else{
                this.empty = true
              }
            }else{
              this.$message.error(res.msg);
            }
          }
        ).catch((err) => {
          this.loading = false
          console.error(err)
        })
      },
    }
  }
</script>
<style lang="stylus" scoped>
  @import '~@/assets/css/zuxie_variable'
  .scroll_wrap {
    height: 100%;
    padding: 20px 0 10px 20px;
    box-sizing: border-box;
    overflow: hidden;

    .info_item {
      margin: 0 30px 30px 10px;

      .info_title {
        font-size: 20px;
        padding: 10px 0 20px;
        display: flex;
        align-items: center;

        img {
          margin-right: 10px;
          width: 26px;
        }
      }

      .base_info {
        border: 1px solid #FFF;
        display: flex;

        .info {
          flex: 1;
        }

        .col {
          /*border-bottom: 1px solid #FFF;*/
          // border-right 1px solid #FFF
          padding: 10px 15px;
          display: flex;
          justify-content: space-around;

          span {
            display: inline-block;
            width: 100%;
          }

          /* &:last-child {
             border-bottom: 0;
           }*/
        }

      }
    }
    .titleWrap{
      select{
        width 210px
      }
      input{
        width 210px
      }
      .ml10{
        margin-left: 10px;
      }
      .search_box{
        display: flex;
        height: 35px;
        margin-left: 10px;
        input{
          padding: 5px;
        }
      }
      .list_wrap{
        flex:1
        overflow:hidden
        .table {
          display flex
          flex-direction column
          flex 1
          width: 100%;
          max-width:830px
          // margin: 30px 0 0;
          .thead, .tbody {
            border: 1px solid $color_white;
          }
          .thead {
            margin-top: 20px;
            .tr {
              height: 45px;
              display: flex;
            }
          }
          .scrollArea {

            padding-bottom:15px
            /*flex 1 */
            /*overflow hidden*/
          }
          .tbodyWrap {
            display block
            // padding: 0 40px;
          }
          .tbody {
            display block
            /*width 810px*/
            /*margin-left auto*/
            /*margin-right auto*/
            /*max-width: 810px;*/
            border-top: none;
            border-bottom: none;
            .tr {
              height: 49px;
              display: flex;
              border-bottom: 1px solid $color_white;
            }
          }
          .th, .td {
            height: 100%;
            /*flex: 1 1 auto;*/
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: $font_size_medium;
            border-right: 1px solid $color_white;
          }
          .th:last-child, .td:last-child {
            border-right: none;
          }
          .td {
            p {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              color: $color_white;
            }
          }
          .seq{
            width 6%
          }
          .name{
            width 15%
            padding 0 5px
            box-sizing border-box
          }
          .organ{
            width: 20%;
          }
          .id_number{
            width:25%;
            padding 0 5px
            box-sizing border-box
          }
          .weizhi{
            width 20%
          }
          .foot{
            width: 14%;
          }
        }
      }
    }
  }

</style>
<style lang="stylus">
  .page-content {
    .el-steps--simple {
      background-color: rgba(0, 0, 0, 0);
    }

    .el-form-item__label {
      color: #fff;
      font-size: 16px;
    }
  }
</style>
